import { Pantalla } from "./componentes";
import { Desglose } from "./Desglose";
import type { Yo } from "./api";
import type { Navegar } from "./navegacion";

/**
 * TERRITORIO: el desglose completo, con migas de pan, para bajar de la
 * campaña al municipio, al distrito y a la sección. Las cifras y la tabla
 * viven en `Desglose.tsx`, que «Hoy» también usa en chico.
 */
export function Territorio({
  yo,
  parametros,
  navegar,
}: {
  yo: Yo;
  parametros: Record<string, unknown>;
  navegar: Navegar;
}) {
  const nodo = typeof parametros["nodo"] === "number" ? (parametros["nodo"] as number) : null;
  return (
    <Pantalla
      titulo="Territorio"
      descripcion={
        yo.alcance.todo
          ? "Toda la campaña, nivel por nivel: lista nominal, padrón, cobertura, verificados y votos para ganar."
          : "Lo que alcanzas, nivel por nivel. Lo de fuera de tu ámbito se dice, no se cuenta en cero."
      }
    >
      <Desglose yo={yo} nodoInicial={nodo} navegar={navegar} />
    </Pantalla>
  );
}
